var map = {
	"./abb-color.svg": 1722,
	"./afb-color.svg": 1723,
	"./afb.svg": 1724,
	"./alb-color.svg": 1725,
	"./alb.svg": 1726,
	"./amb-color.svg": 1727,
	"./amb.svg": 1728,
	"./bbbaidja-color.svg": 1729,
	"./bbbaidjaxxx-color.svg": 1730,
	"./bdinidjaxxx-color.svg": 1731,
	"./bimb-color.svg": 1732,
	"./bimb.svg": 1733,
	"./bkr-color.svg": 1734,
	"./bkr.svg": 1735,
	"./bmriidja-color.svg": 1736,
	"./bniaidja-color.svg": 1737,
	"./bninidja-color.svg": 1738,
	"./bninidjaxxx-color.svg": 1739,
	"./bpay-color.svg": 1740,
	"./brinidja002-color.svg": 1741,
	"./bsmdidjaxxx-color.svg": 1742,
	"./bsn-color.svg": 1743,
	"./bsn.svg": 1744,
	"./btanidjaxxx-color.svg": 1745,
	"./cenaidja-color.svg": 1746,
	"./cenaidjaxxx-color.svg": 1747,
	"./cimb-color.svg": 1748,
	"./cimb.svg": 1749,
	"./citi-color.svg": 1750,
	"./citi.svg": 1751,
	"./default-bank-icon-color.png": 1752,
	"./default-bank-icon.png": 1753,
	"./gxbank-color.svg": 1754,
	"./hlb-color.svg": 1755,
	"./hlb.svg": 1756,
	"./hsbc-color.svg": 1757,
	"./hsbc.svg": 1758,
	"./ibbkidjaxxx-color.svg": 1759,
	"./kwh-color.svg": 1760,
	"./kwh.svg": 1761,
	"./mbb-color.svg": 1762,
	"./mbb.svg": 1763,
	"./nispidjaxxx-color.svg": 1764,
	"./ocbc-color.svg": 1765,
	"./ocbc.svg": 1766,
	"./pbb-color.svg": 1767,
	"./pbb.svg": 1768,
	"./pinbidja-color.svg": 1769,
	"./rhb-b.svg": 1770,
	"./rhb-color-b.svg": 1771,
	"./rhb-color.svg": 1772,
	"./rhb.svg": 1773,
	"./scb-color.svg": 1774,
	"./scb.svg": 1775,
	"./tng-color.svg": 1776,
	"./uob-color.svg": 1777,
	"./uob.svg": 1778
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 108;